import { Grid, Step, Typography } from "@mui/material"
import { FormStepperProps, IStepIconProps } from "components/Form/Stepper/formstepper.interface"
import React from "react"
import { useTranslation } from "react-i18next"
import { StyledStepLabel, StyledStepper } from "shared/styled/General"

const StepIcon: React.FC<IStepIconProps> = (props) => {
  const { active, completed } = props
  return active ? null : completed ? null : null
}

export const FormStepper: React.FC<FormStepperProps> = (props) => {
  const { areas, activeStep, name, translationData } = props
  const { t } = useTranslation()

  return (
    <Grid container direction="column" alignItems="center" justifyContent="center" pb={4}>
      <Grid item>
        <Typography variant="h3">
          {t(`${translationData?.formTypeKey}.title_prefix`, "Report deviation")}: {t(`global.features.title.${translationData?.formNameKey}`, { defaultValue: name })}
        </Typography>
      </Grid>
      {areas.length > 1 && (
        <Grid item>
          <StyledStepper connector={null} sx={{ gap: 2, flexWrap: "wrap" }} activeStep={activeStep} orientation="horizontal">
            {areas?.map((area: any, index: any) => {
              return (
                <Step sx={{ padding: 0 }} key={index}>
                  <StyledStepLabel StepIconComponent={StepIcon}>
                    {area.step + 1}. {t(`${translationData?.formTypeKey}.${area.labelKey}`, { defaultValue: area.labelDefault || "" })}
                  </StyledStepLabel>
                </Step>
              )
            })}
          </StyledStepper>
        </Grid>
      )}
    </Grid>
  )
}
